// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"eec12403","570":"2ef81caf","631":"eec12403","737":"eec12403"}[chunkId] + ".chunk.css";
};